import { useReducer } from 'react';

export const useRender = () => {
    const state = useReducer(() => ({}), {});

    return state;
};
